'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

const isServiceDetailPath = (pathname: string) => /^\/services\/[^/]+\/?$/.test(pathname);

export default function SmoothScroll() {
  const pathname = usePathname();

  const scrollToPageStart = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  useEffect(() => {
    const previousScrollRestoration = window.history.scrollRestoration;
    window.history.scrollRestoration = 'manual';
    if (isServiceDetailPath(window.location.pathname)) {
      scrollToPageStart();
    }

    return () => {
      window.history.scrollRestoration = previousScrollRestoration;
    };
  }, []);

  useEffect(() => {
    const handleScrollTop = () => scrollToPageStart();
    window.addEventListener('creator-tech:scroll-top', handleScrollTop);

    return () => {
      window.removeEventListener('creator-tech:scroll-top', handleScrollTop);
    };
  }, []);

  useEffect(() => {
    if (!isServiceDetailPath(pathname)) return;

    scrollToPageStart();
    const rafId = requestAnimationFrame(scrollToPageStart);
    const timeoutId = window.setTimeout(scrollToPageStart, 120);

    return () => {
      cancelAnimationFrame(rafId);
      window.clearTimeout(timeoutId);
    };
  }, [pathname]);

  return null;
}
